 (function () {
     'use strict';

     angular.module('app').component('popup', {
         templateUrl: ['$rootScope', function ($rootScope) {
             let templatePath = `@/popups/`;
             if ($rootScope.popupOptions.isRestrictive) return `${templatePath}blocking-popup.html`;
             if ($rootScope.popupOptions.isDialog) return `${templatePath}info-popup-textarea.html`;
             return `${templatePath}info-popup.html`;
         }],
         bindings: {
             options: '='
         },
         controller: PopupController
     });
     PopupController.$inject = ["$document"];
     function PopupController($document) {
         const $controller = this;
         $controller.$onInit = initialize;
         function initialize() {
             if ($controller.options.isRestrictive) {
                 const backgroundColor = 'retour';
                 $document[0].querySelector(".modal-body").classList.add(backgroundColor);
                 $document[0].querySelector(".modal-footer").classList.add(backgroundColor);
             }
         }
     }
 })();
